const sameId = (left, right) => String(left) === String(right)

const accessibleEditorName = (baseName, orderedIds, id) => {
  const ids = Array.isArray(orderedIds) ? orderedIds : []
  if (ids.length < 2) return baseName
  const index = ids.findIndex((item) => sameId(item, id))
  if (index < 0) return baseName
  return `${baseName} ${index + 1}`
}

const orderedPageAnswerIds = (page, answersById) => {
  const questionIds = Array.isArray(page?.questions) ? page.questions : []
  const pageAnswerIds = Array.isArray(page?.answers) ? page.answers : []
  const answers = answersById || {}
  const ids = []
  questionIds.forEach((questionId) => {
    pageAnswerIds
      .map((answerId) => answers[answerId])
      .filter((item) => item && sameId(item.questionId, questionId))
      .sort((a, b) => a.order - b.order)
      .forEach((item) => ids.push(item.id))
  })
  return ids
}

export { orderedPageAnswerIds }
export default accessibleEditorName
